// Persona mappings for all professions
export const personaMap = {
  'Software Engineer': () => import('./software-engineer.json'),
  'Account Executive': () => import('./account-executive.json'),
  'Healthcare Professional': () => import('./healthcare-professional.json'),
  'Marketing Specialist': () => import('./marketing-specialist.json'),
  'Environmental Scientist': () => import('./environmental-scientist.json'),
  'Financial Advisor': () => import('./financial-advisor.json'),
  'Civil Engineer': () => import('./civil-engineer.json'),
  'Management Consultant': () => import('./management-consultant.json'),
  'Legal Counsel': () => import('./legal-counsel.json'),
  'Creative Director': () => import('./creative-director.json'),
  'Education Leader': () => import('./education-leader.json'),
  'Sales Executive': () => import('./sales-executive.json'),
  'Corporate Executive': () => import('./corporate-executive.json'),
  'HR Specialist': () => import('./hr-specialist.json'),
  'Business Consultant': () => import('./business-consultant.json'),
  'Product Manager': () => import('./product-manager.json'),
  'Operations Manager': () => import('./operations-manager.json'),
  'Real Estate Agent': () => import('./real-estate-agent.json'),
  'Startup Founder': () => import('./startup-founder.json'),
  'Hospitality Manager': () => import('./hospitality-manager.json'),
  'Research Scientist': () => import('./research-scientist.json'),
  'Retail Manager': () => import('./retail-manager.json'),
  'Nonprofit Director': () => import('./nonprofit-director.json'),
  'Project Manager': () => import('./project-manager.json'),
  'Executive Leader': () => import('./executive-leader.json')
};

/**
 * Get persona data for a specific profession
 * @param {string} professionName - The name of the profession
 * @returns {Promise<Object|null>} The persona form data or null if not found
 */
export const getPersonaData = async (professionName) => {
  try {
    const personaLoader = personaMap[professionName];
    if (!personaLoader) {
      console.warn(`No persona found for profession: ${professionName}`);
      return null;
    }
    
    const personaModule = await personaLoader();
    return personaModule.default || personaModule;
  } catch (error) {
    console.error(`Error loading persona for ${professionName}:`, error);
    return null;
  }
};

/**
 * Convert profession name to URL-safe persona ID
 * @param {string} professionName - The profession name
 * @returns {string} URL-safe persona ID
 */
export const professionToPersonaId = (professionName) => {
  return professionName
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
};

/**
 * Convert persona ID back to profession name
 * @param {string} personaId - The persona ID
 * @returns {string|null} The profession name or null if not found
 */
export const personaIdToProfession = (personaId) => {
  const professionNames = Object.keys(personaMap);
  return professionNames.find(name => 
    professionToPersonaId(name) === personaId
  ) || null;
}; 